'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app, $stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state('app', {
    url: '/',
    abstract: true,
    template: require('pages/app/index.tpl.html')
  }).state('home', {
    parent: 'app',
    url: '^/home',
    template: require('pages/home/index.tpl.html'),
    controller: 'homeCtrl',
    data: {
      authorizedRoles: []
    }
  }).state('bar', {
    parent: 'app',
    url: '^/bar',
    template: require('pages/bar/index.tpl.html'),
    controller: 'barCtrl',
    data: {
      authorizedRoles: []
    }
  }).state('button', {
    parent: 'app',
    url: '^/button',
    template: require('pages/button/index.tpl.html'),
    controller: 'buttonCtrl',
    data: {
      authorizedRoles: []
    }
  }).state('common', {
    parent: 'app',
    url: '^/common',
    template: require('pages/common/index.tpl.html'),
    controller: 'commonCtrl',
    data: {
      authorizedRoles: []
    }
  });

  $urlRouterProvider.otherwise(function ($injector) {
    var $rootScope = $injector.get('$rootScope');
    $rootScope.goHome();
  });
};

; /**
   * APP 路由 配置
   * 注册 state
   */


//////////////////
// WEBPACK FOOTER
// ./src/app/route.config.js
// module id = 37
// module chunks = 0